// Libraries
import { useEffect, useState } from 'react';
// Redux
import { RootState } from '@redux/rootReducer';
import { useAppDispatch, useAppSelector } from '@hooks/redux';
// Api
import {
    failedRequest,
    getCheckEmployerStatus,
    getYearPeriodTransmit,
    setStartTransmit,
} from '@redux/electronic-payroll/electronicPayroll.slice';
import { CurrentTabs } from '../constants/Tabs';

export const useEnablePayroll = (): {
    hasElectronicPayroll: boolean;
    token: string;
    startTransmit: boolean;
    showErrorModal: boolean;
    showLoaderElectronicPayroll: boolean;
    handleStartTransmit: () => void;
    handleCheckElectronicPayrollStatus: () => Promise<void>;
} => {
    const dispatch = useAppDispatch();
    const {
        electronicPayroll: { currentTab, startTransmit, hasElectronicPayroll, token, error: electronicPayrollError },
        session: { loginUser },
    } = useAppSelector((state: RootState) => state);
    const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
    const [showLoaderElectronicPayroll, setShowLoaderElectronicPayroll] = useState<boolean>(false);

    useEffect(() => {
        if (loginUser?.lastLogin) {
            Promise.all([handleCheckElectronicPayrollStatus(), dispatch(getYearPeriodTransmit())]);
        }
    }, []);

    useEffect(() => {
        if (electronicPayrollError !== '') setShowErrorModal(true);
    }, [electronicPayrollError]);

    /**
     * Action to start transmit from electronic payroll
     */
    const handleStartTransmit = (): void => {
        dispatch(getCheckEmployerStatus(true));
        dispatch(setStartTransmit(true));
    };

    const handleCheckElectronicPayrollStatus = async (): Promise<void> => {
        setShowLoaderElectronicPayroll(true);
        setShowErrorModal(false);
        dispatch(failedRequest(''));
        await dispatch(getCheckEmployerStatus());
        setShowLoaderElectronicPayroll(false);
    };

    return {
        hasElectronicPayroll,
        token,
        startTransmit,
        showErrorModal,
        showLoaderElectronicPayroll,
        handleStartTransmit,
        handleCheckElectronicPayrollStatus,
    };
};
